import * as React from "react";
import { SectionHeader } from "../../../../Dashboard/Components/Clients/Common/SharedComponents";
import { RadiosEditor } from "../../../../../react-core/Html/RadiosEditor";
import { ProcessType, OffPlatformAssetBuyReminderMessage } from "../../Resource/Content";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InstrumentSelections } from "../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { SubAccountTypeHelper } from "../../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSelection } from "../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";

interface IOffPlatformAdviceGiven
{
    data: InstrumentSelections;
    type: ProcessType;
    product: SubAccountType;
    isAdviceGiven?: boolean;
    onChange: (val: boolean) => void;
}

export const OffPlatformAdviceGiven = (props: IOffPlatformAdviceGiven) => {
    const instrumentHasAllocation = (instrument: InstrumentSelection): boolean => (
        instrument.ClientRegular?.Percentage > 0 ||
            instrument.EmployerRegular?.Percentage > 0 ||
            instrument.EmployerSalaryDeductionRegular?.Percentage > 0 ||
            instrument.Single?.Percentage > 0 ||
            instrument.ThirdPartyRegular?.Percentage > 0 ||
            instrument.Transfer?.Percentage > 0
    );

    const isAdviceGivenRequired: boolean = 
        !(
            !SubAccountTypeHelper.isOnPlatformPension(props.product) ||
            !(props.type == ProcessType.NB ||
                props.type == ProcessType.NBEC ||
                props.type == ProcessType.SinglePayment ||
                props.type == ProcessType.TopUpWithITFLS ||
                props.type == ProcessType.Buy ||
                props.type == ProcessType.AddRegular ||
                props.type == ProcessType.EditRegular) ||
            !props.data || !props.data.Instruments || props.data.Instruments.length == 0
        ) && 
        props.data.Instruments.some((ele) => [ProductType.OffPlatform].includes(ele.Instrument.Type) && instrumentHasAllocation(ele));

    return (isAdviceGivenRequired &&
                <>
                    <p>{ OffPlatformAssetBuyReminderMessage }</p>
                    {SectionHeader("Did you give financial advice on this Transaction?")}
                    <RadiosEditor
                        cssWrapper="control-size-430 mb-30 rg-inline"
                        selected={props?.isAdviceGiven}
                        options={[true, false]}
                        onChange={(v) => props.onChange(v)}
                        required={"Please select"}
                        getText={(v) => (v ? "Yes" : "No")}
                    />
                </>
            );
}